import { queryOptions } from '@tanstack/react-query';
import { Locale } from '@/utility/locale';
import { get, toQueryString } from '@/utility/requestHelpers/clientRequestHelpers';
import { ALL_RATINGS } from './constants';

export const initialReviewsFilter = {
  offset: 0,
  selectedRating: ALL_RATINGS,
};

export const getProductReviewQueryOptions = (
  productTypeId: string,
  locale: Locale,
  reviewFilter = initialReviewsFilter
) =>
  queryOptions({
    queryKey: ['productTypeRating', productTypeId, locale, reviewFilter],
    queryFn: async () => {
      const rating = await get<ProductTypeRating | null>(
        `/internal/api/productTypeRating?${toQueryString({
          productTypeId,
          locale,
          ratingScale: reviewFilter.selectedRating,
          offset: reviewFilter.offset,
        })}`
      );
      return rating ?? null;
    },
    staleTime: 60 * 60 * 1000, // 1 hour
    select: (data) => data ?? undefined,
  });
